import { Decimal } from 'decimal.js';
export function toNumber(val: any, removeDot: boolean = false): number {
  if (!val) {
    return 0;
  }

  let returnVal = val.toString();

  if (removeDot) {
    returnVal = returnVal.replace(/\./g, '');
  }

  returnVal = returnVal.replace(',', '.');
  returnVal = parseFloat(returnVal);

  return isNaN(returnVal) ? 0 : returnVal;
}
